module.exports = __webpack_public_path__ + "static/media/7.213287c0.jpeg";